export enum ClientOnboardingStepKey {
  Welcome,
  BasicInformation,
  LicenseAndPricing,
  MasterServiceAgreement,
  Payment,
  OrganizationSetup,
}
